<template>
  <div>
    <AppNavbar />
    <div class="returns-page">
      <section class="hero-outer-bleed">
        <div class="hero-section">
          <div class="hero-glow one"></div>
          <div class="hero-glow two"></div>

          <div class="hero-container reveal">
            <h1>Return & Refund Policy</h1>
          </div>
        </div>
      </section>

      <section class="content-outer-bleed">
        <div class="content-section">
          <div class="content-wrapper reveal">
            <p class="intro-text">
              This Policy sets out the Company's return, replacement, refund,
              and buy-back terms applicable to all purchases made through the
              Company's authorised direct selling channels. It is to be read
              together with the Direct Seller Agreement and the Company's
              Grievance Redressal Mechanism.
            </p>
            <p class="intro-text">
              Nothing in this Policy limits or restricts any statutory right
              available to Customers or Direct Sellers under applicable consumer
              protection laws of India.
            </p>

            <!-- Section 1 -->
            <div class="policy-block">
              <h3>1. Applicability & Authorised Channels</h3>
              <p>
                1.1. This Policy applies only to products purchased through the
                Company's authorised channels: its official website, mobile
                application, registered Direct Sellers, or Company-operated
                warehouses.
              </p>
              <p>
                1.2. Products purchased through unauthorised or unverified
                third-party sources (including unauthorised e-commerce listings)
                are not eligible for return, replacement, refund, or any benefit
                under this Policy.
              </p>
              <p>
                1.3. This Policy applies uniformly to Customers and Direct
                Sellers, except where a clause expressly distinguishes between
                the two.
              </p>
            </div>

            <!-- Section 2 -->
            <div class="policy-block">
              <h3>2. Cooling-Off Period for New Direct Sellers</h3>
              <p>
                2.1. In accordance with the Direct Selling Rules, every newly
                enrolled Direct Seller is entitled to a Cooling-Off Period of
                thirty (30) working days from the date of enrolment, during
                which the Direct Seller may withdraw from the direct selling
                business without penalty.
              </p>
              <p>
                2.2. Where a Direct Seller exercises this right within the
                Cooling-Off Period, the Company shall buy back all Marketable
                Products and business/promotional materials purchased by such
                Direct Seller during the Cooling-Off Period, and shall refund
                the amount paid less any Business Volume / Sales Incentive
                already utilised or paid out in connection with such purchases
                within thirty (30) working days of receipt of the returned
                products.
              </p>
              <p>
                2.3. This Clause 1 is in addition to, and not in lieu of, the
                standard Product Refund Policy set out in Clause 3.
              </p>
            </div>

            <!-- Section 3 -->
            <div class="policy-block">
              <h3>
                3. Return & Replacement — Wrong, Damaged, or Short-Shipped
                Products
              </h3>
              <p>
                3.1. If the product(s) received differ from what was ordered, or
                are damaged or short in quantity, the Customer/Direct Seller
                must notify the Company within seven (7) working days of
                receipt, by email to
                <a href="mailto:customercare@indiekonnect.com"
                  >customercare@indiekonnect.com</a
                >
                or such other channel as the Company may designate, enclosing:
                (a) the order/invoice number; (b) photographs of the product,
                packaging, and shipping label; and (c) a completed product
                exchange/return form.
              </p>
              <p>
                3.2. On verification, the Company shall dispatch the
                correct/replacement product within seven (7) working days of
                receiving the returned product at its warehouse, or, where the
                Customer/Direct Seller prefers, process a full refund of the
                amount paid (excluding shipping charges, if any) within fifteen
                (15) working days.
              </p>
              <p>
                3.3. Where dispatch is delayed due to non-availability of stock,
                the Company shall notify the Customer/Direct Seller of the
                revised dispatch schedule by email.
              </p>
              <p>
                3.4. Combo / multi-product orders: a refund request for a combo
                pack or multi-product order must cover all products in that
                combo/order. The Company will not process a partial refund of
                selected items within a combo or single purchase order.
              </p>
              <p>
                3.5. Total quantity returned under this Policy cannot exceed the
                quantity reflected on the original invoice.
              </p>
              <p>
                3.6. No refund request will be entertained after the applicable
                return window.
              </p>
            </div>

            <!-- Section 4 -->
            <div class="policy-block">
              <h3>4. Return Process & Logistics</h3>
              <p>
                4.1. Return requests must be raised by email to
                <a href="mailto:customercare@indiekonnect.com"
                  >customercare@indiekonnect.com</a
                >
                or through the Distributor/Customer portal, accompanied by the
                completed return form and supporting documentation.
              </p>
              <p>
                4.2. Where reverse pickup is available at the Customer's/Direct
                Seller's location, the Company shall arrange pickup at no cost.
                Where reverse pickup is not available, the Customer/Direct
                Seller shall courier the product to the nearest Company
                warehouse, and the cost of such shipment shall be borne by the
                Customer/Direct Seller except where the return arises from
                Company error, manufacturing defect, or transit damage under
                Clause 3, in which case the Company bears the cost.
              </p>
              <p>
                4.3. The return period is calculated from the invoice date to
                the date of receipt at the Company's warehouse, not the date of
                dispatch by the Customer/Direct Seller.
              </p>
              <p>
                4.4. All returned products are subject to quality inspection on
                receipt. The Company shall determine eligibility (Marketable /
                Partially Used / ineligible) in line with this Policy and shall
                notify the Customer/Direct Seller of the outcome, including
                reasons for any rejection.
              </p>
            </div>

            <!-- Section 5 -->
            <div class="policy-block">
              <h3>5. Excess Stock & Anti-Inventory-Loading Provision</h3>
              <p>
                5.1. Direct Sellers are not required to purchase Excess Stock as
                a condition of enrolment, rank advancement, or continued
                participation in the Company's direct selling network.
              </p>
              <p>
                5.2. Where a Direct Seller has purchased Excess Stock, the
                Company shall accept the return of such Excess Stock, in
                Marketable condition, within 30 working days of the invoice
                date, on the refund basis set out in Clause 3.
              </p>
            </div>

            <!-- Section 6 -->
            <div class="policy-block">
              <h3>
                6. Business Volume / Sales Incentive (Commission) Adjustment
              </h3>
              <p>
                6.1. Where a refund or buy-back is processed under this Policy,
                any Business Volume / Sales Incentive credited to the returning
                Direct Seller, and/or to any upline Direct Seller, in connection
                with the returned product, shall be reversed and clawed back
                from the relevant Direct Seller's account in the month the
                return is processed.
              </p>
              <p>
                6.2. Where a Customer returns a product directly to the Company
                without routing the return through the relevant Direct Seller,
                the Business Volume / Sales Incentive adjustment shall still be
                made against the concerned Direct Seller's account, and any
                incentive amount already paid out in excess shall be recoverable
                from such Direct Seller.
              </p>
              <p>
                6.3. Adjustments for products returned on or before the 25th of
                a calendar month shall be processed within that month;
                adjustments for returns after the 25th shall be processed in the
                following month.
              </p>
            </div>

            <!-- Section 7 -->
            <div class="policy-block">
              <h3>7. Refund Timelines & Mode of Payment</h3>
              <p>
                7.1. Refunds approved under this Policy shall be processed
                within fifteen (15) working days of receipt and verification of
                the returned product(s) at the Company's warehouse.
              </p>
              <p>
                7.2. Refunds shall be credited to the original mode of payment,
                or to the Customer's/Direct Seller's registered bank account
                where the original mode is not feasible. Where neither is
                feasible, the Company may issue the refund by demand draft.
              </p>
              <p>
                7.3. Applicable deductions including TDS, GST/other applicable
                taxes, and Business Volume / Sales Incentive adjustments under
                Clause 6 shall be itemised and communicated to the
                Customer/Direct Seller at the time the refund is processed.
              </p>
              <p>
                7.4. For interstate returns, applicable GST shall be deducted
                from the refund amount. Customers/Direct Sellers are advised to
                route returns to the warehouse/location stated on the original
                invoice to avoid such deductions.
              </p>
            </div>

            <!-- Section 8 -->
            <div class="policy-block">
              <h3>
                8. Exclusions — Not Eligible for Return, Replacement, or Refund
              </h3>
              <p>
                The following are not eligible for return, replacement, or
                refund under this Policy:
              </p>
              <ul class="exchange-list">
                <li>
                  Products damaged due to misuse, mishandling, or improper
                  storage by the Customer/Direct Seller;
                </li>
                <li>
                  Products with tampered, missing, or altered packaging, labels,
                  or seals;
                </li>
                <li>
                  Products purchased through unauthorised channels (see Clause
                  2);
                </li>
                <li>
                  Opened packs of literature, promotional videos, or sales aids;
                </li>
                <li>Personalised or customised products;</li>
                <li>
                  Products returned without all original components,
                  accessories, or packaging;
                </li>
                <li>
                  Products that are expired, discontinued, or part of a seasonal
                  range at the time the return request is raised.
                </li>
              </ul>
            </div>

            <!-- Section 9 -->
            <div class="policy-block">
              <h3>9. Fraud Prevention & Misuse of Policy</h3>
              <p>
                9.1. The Company reserves the right to monitor return and refund
                patterns and may, at its discretion, refuse a return,
                replacement, refund, or buy-back request where it reasonably
                suspects misuse, abuse of this Policy, or fraudulent activity,
                including repeated returns inconsistent with genuine consumption
                patterns.
              </p>
              <p>
                9.2. In accordance with the Direct Selling Rules, the Company
                may maintain a record of Customers/Direct Sellers who repeatedly
                offer defective or spurious goods or raise disputed product
                claims.
              </p>
            </div>

            <!-- Section 10 -->
            <div class="policy-block">
              <h3>10. Customer Support & Grievance Redressal</h3>
              <p>
                10.1. For queries relating to returns, replacements, or refunds,
                Customers and Direct Sellers may contact the Company's customer
                support team at
                <a href="mailto:customercare@indiekonnect.com"
                  >customercare@indiekonnect.com</a
                >
                or [customer support phone number].
              </p>
              <p>
                10.2. In accordance with the Direct Selling Rules, the Company
                has appointed a Grievance Redressal Officer, whose name and
                contact details are published on the Company's website. The
                Grievance Redressal Officer shall acknowledge receipt of a
                complaint within forty-eight (48) working hours and shall
                endeavour to resolve it within one (1) month of receipt.
              </p>
              <p>
                10.3. Unresolved grievances may be escalated in accordance with
                the Company's Grievance Redressal Mechanism, available at
                <a href="mailto:customercare@indiekonnect.com"
                  >customercare@indiekonnect.com</a
                >
                or to the appropriate Consumer Forum/Authority under the
                Consumer Protection Act, 2019.
              </p>
            </div>

            <!-- Section 11 -->
            <div class="policy-block">
              <h3>11. Legal & Compliance</h3>
              <p>
                11.1. The Company is registered with the Department for
                Promotion of Industry and Internal Trade (DPIIT) as a direct
                selling entity. This Policy is framed in accordance with the
                Consumer Protection Act, 2019, the Consumer Protection (Direct
                Selling) Rules, 2021, and other laws applicable in India.
              </p>
              <p>
                11.2. Nothing in this Policy restricts or waives any statutory
                right available to Customers or Direct Sellers under applicable
                Indian Consumer Protection Laws.
              </p>
              <p>
                11.3. This Policy is governed by the laws of India. Any dispute
                arising out of or in connection with this Policy shall be
                subject to the exclusive jurisdiction of the courts at Delhi &
                Punjab, India, save that disputes with Direct Sellers shall
                first be addressed in accordance with the Dispute Resolution
                Mechanism specified in the Direct Seller Agreement.
              </p>
              <p>
                11.4. The Company shall not be liable for any delay or failure
                in performance under this Policy arising from causes beyond its
                reasonable control.
              </p>
              <p>
                11.5. The Company reserves the right to amend this Policy at any
                time. Material changes will be notified to Customers and Direct
                Sellers through the Company's website and/or registered email.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <FooterView />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import FooterView from "../FooterView.vue";
import AppNavbar from "../AppNavbar.vue";

onMounted(() => {
  const body = document.body;
  if (body) {
    body.style.setProperty("margin", "0", "important");
    body.style.setProperty("padding", "0", "important");
    body.style.setProperty("max-width", "100%", "important");
  }

  const revealElements = document.querySelectorAll(".reveal");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    { threshold: 0.08 },
  );
  revealElements.forEach((el) => observer.observe(el));
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800&display=swap");

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.returns-page {
  width: 100% !important;
  max-width: 100% !important;
  font-family: "Raleway", sans-serif;
  background: #ffffff;
  color: #2d3748;
}

.hero-outer-bleed {
  width: 100% !important;
  background: #003da5 !important;
  display: block;
}

.hero-section {
  position: relative;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 50px 24px 20px;
  overflow: hidden;
  z-index: 1;
}

.hero-container {
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
}

.hero-glow.one {
  width: 350px;
  height: 350px;
  background: rgba(255, 199, 44, 0.15);
  top: -100px;
  right: -50px;
}

.hero-glow.two {
  width: 300px;
  height: 300px;
  background: rgba(255, 255, 255, 0.06);
  bottom: -100px;
  left: -50px;
}

.hero-container h1 {
  color: #ffc72c;
  font-size: 46px;
  line-height: 1.1;
  margin-bottom: 16px;
  font-weight: 800;
}

.hero-text {
  color: rgba(255, 255, 255, 0.88);
  font-size: 17px;
  line-height: 1.7;
  max-width: 720px;
  margin-bottom: 28px;
}

.content-outer-bleed {
  width: 100% !important;
  background: #ffffff;
  display: block;
}

.content-section {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 35px 24px 60px;
}

.content-wrapper {
  width: 100%;
}

.content-wrapper h2 {
  font-size: 28px;
  line-height: 1.3;
  color: #003da5;
  margin-bottom: 26px;
  font-weight: 800;
}

.intro-text {
  color: #4c5661;
  font-size: 16px;
  line-height: 1.9;
  font-weight: 500;
  max-width: 980px;
  margin-bottom: 16px;
}

.policy-block {
  margin-top: 36px;
}

.policy-block h3 {
  font-size: 20px;
  color: #003da5;
  font-weight: 800;
  margin-bottom: 14px;
}

.policy-block p {
  color: #4c5661;
  font-size: 16px;
  line-height: 1.9;
  font-weight: 500;
  margin-bottom: 10px;
  max-width: 980px;
}

.policy-block p a {
  color: #003da5;
  text-decoration: underline;
  font-weight: 600;
}

.policy-block p a:hover {
  color: #ffc72c;
}

.exchange-list {
  padding-left: 24px;
  margin-top: 10px;
}

.exchange-list li {
  color: #4c5661;
  font-size: 16px;
  line-height: 1.9;
  margin-bottom: 8px;
  font-weight: 500;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

@media (max-width: 768px) {
  .hero-section {
    padding: 40px 20px 20px;
  }

  .hero-container h1 {
    font-size: 26px;
  }

  .content-section {
    padding: 30px 20px 40px;
  }

  .intro-text,
  .policy-block p,
  .exchange-list li {
    font-size: 15px;
    line-height: 1.8;
  }

  .policy-block h3 {
    font-size: 18px;
  }
}
</style>
